export const SET_HOMEPAGE_DATA = 'challan/SET_HOMEPAGE_DATA';
export const GET_RECENT_SEARCH = 'challan/GET_RECENT_SEARCH';
export const SET_OTP_DATA = 'challan/SET_OTP_DATA';
export const SET_REFRESH_CHALLANS = 'challan/SET_REFRESH_CHALLANS';
export const UPDATE_SELECTED_VEHICLE = 'challan/UPDATE_SELECTED_VEHICLE';
export const UPDATE_VEHICLE_LIST = 'challan/UPDATE_VEHICLE_LIST';
export const UPDATE_LOCATION_CHALLAN_DATA = 'challan/UPDATE_LOCATION_CHALLAN_DATA';
export const UPDATE_LOCATION = 'challan/UPDATE_LOCATION';
export const SET_RECENTLY_UPDATED = 'challan/SET_RECENTLY_UPDATED';
export const SET_SELECTED_PAYABLE_CHALLAN = 'challan/SET_SELECTED_PAYABLE_CHALLAN';
export const CHALLAN_DAY_ACTIVE = 'challan/CHALLAN_DAY_ACTIVE';
export const CALL_BACK_REQUESTED = 'challan/CALL_BACK_REQUESTED';
export const FUEL_REWARD= 'challan/FUEL_REWARD';
export const PAYMENT_PAGE_INFO= 'challan/PAYMENT_PAGE_INFO';
export const BY_PASS_TO_LISTING= 'challan/BY_PASS_TO_LISTING';



